export const useGtmEvent = () => {
  const pushEvent = (event: string, params?: Record<string, unknown>) => {
    if (import.meta.env.VITE_ENVIRONMENT !== "prod") return;
    if (!window.dataLayer) window.dataLayer = [];

    window.dataLayer.push({ event, ...params });
  };

  return { pushEvent };
};
